import { graphql } from 'gatsby';
import GlobalHead from '@klaviyo-mkt/gatsby-theme-marketing/src/templates/layout/head';
import BlogHome from '../../templates/static/blog';

import type { HeadProps } from 'gatsby';
import type { IBlogHomeData } from '../../templates/static/blog';

export const query = graphql`
  query BlogHome {
    defaultPage(isPostsPage: {eq: true}) {
      ...BlogHomeDetails
    }
  }
`;

export const Head = ({
  data,
  location,
}: HeadProps<IBlogHomeData>) => (
  <GlobalHead
    pathname={location.pathname}
    seo={{
      ...data?.defaultPage?.headlessSeo,
      canonical: '/blog',
    }}
    translations={data?.defaultPage?.translations}
  />
);

export default BlogHome;
